import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, MaybeAsync, Resolve, RouterStateSnapshot } from '@angular/router';
import {
  SubpageAppEntitySubpageRead,
  SurveyBaseAllBaseReadSurveyAllSurveyReadSurveyItemRead,
  SurveyService
} from '../openapi';
import { selectSubpages } from '../store/selectors/app.selectors';
import { filter, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurveyResolver implements Resolve<SubpageAppEntitySubpageRead | null> {

  constructor(private surveyService: SurveyService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<SurveyBaseAllBaseReadSurveyAllSurveyReadSurveyItemRead> {
    return this.surveyService.apiSurveysGetItemSurveyItem({
      id: route.params['surveyId']
    })
  }
}
